import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPermissions } from "../redux/permissionsSlice";
import fetchStatusCounts from "../GlobalFunction/Counts";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Ticketing = () => {
  const names = ["Category", "SubCategory"];
  const location = useLocation();
  const navigate = useNavigate();
  const [counts, setCounts] = useState([]);

  const permissions = useSelector(selectPermissions);

  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      (permission) => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };


  const parentId = 40;

  useEffect(() => {
    const getCounts = async () => {
      const data = await fetchStatusCounts(parentId);
      setCounts(data);
    };
    getCounts();
  }, [parentId])


  const matchedItem = (moduleName) => {
    return counts.find(item => item.ModuleName === moduleName);
  };

  const matchCategory = matchedItem('Ticket Category');
  const matchSubcategory = matchedItem('Ticket SubCategory')
  const matchWarden = matchedItem('Warden/Vendor Allocation');
  const matchService = matchedItem('Service/Complaint Master');

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        sx={{
          width: "100%",
          maxWidth: "100%"
        }}
      >
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasModulePermission("Ticket Category") && matchCategory && (
              <BoxWithIcon
                totalCount={matchCategory.TotalCount}
                activeCount={matchCategory.ActiveCount}
                inactiveCount={matchCategory.InactiveCount}
                link={{ pathname: "/ticket-category-table" }}
                permissions={permissions}
                title="Ticket Category"
              />
            )}

            {/* {hasModulePermission("Warden/Vendor Allocation") && matchWarden && (
              <BoxWithIcon
                totalCount={matchWarden.TotalCount}
                activeCount={matchWarden.ActiveCount}
                inactiveCount={matchWarden.InactiveCount}
                link={{ pathname: "/warden-allocation-table" }}
                title="Warden/Vendor Allocation"
              />
            )} */}
            
            {hasModulePermission("Property Wise Category Allocation") && matchWarden && (
              <BoxWithIcon
                totalCount={matchWarden.TotalCount}
                activeCount={matchWarden.ActiveCount}
                inactiveCount={matchWarden.InactiveCount}
                link={{ pathname: "/property-wise-category-allocation-table" }}
                title="Property Wise Category Allocation"
              />
            )}
            {hasModulePermission("Ticket SubCategory") && matchSubcategory && (
              <BoxWithIcon
                totalCount={matchSubcategory.TotalCount}
                activeCount={matchSubcategory.ActiveCount}
                inactiveCount={matchSubcategory.InactiveCount}
                link={{ pathname: "/ticket-subcategory-table" }}
                permissions={permissions}
                title="Ticket SubCategory"
              />
            )}
            {hasModulePermission("Service/Complaint Master") && matchService && (
              <BoxWithIcon
                totalCount={matchService.TotalCount}
                activeCount={matchService.ActiveCount}
                inactiveCount={matchService.InactiveCount}
                link={{ pathname: "/service-table" }}
                permissions={permissions}
                title="Service/Complaint Master"
              />
            )}

          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Ticketing;
